const STYLES = {
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  confirmed: "bg-blue-50 text-blue-800 border-blue-200",
  completed: "bg-green-50 text-green-700 border-green-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
  paid: "bg-green-50 text-green-700 border-green-200",
  unpaid: "bg-amber-50 text-amber-700 border-amber-200",
  pay_at_desk: "bg-blue-50 text-blue-800 border-blue-200",
  pending_payment: "bg-amber-50 text-amber-700 border-amber-200",
  refund_pending: "bg-amber-50 text-amber-700 border-amber-200",
  refunded: "bg-slate-100 text-slate-600 border-slate-200",
  not_required: "bg-slate-100 text-slate-500 border-slate-200",
  created: "bg-blue-50 text-blue-800 border-blue-200",
  failed: "bg-red-50 text-red-700 border-red-200",
};

const LABELS = {
  pending: "Pending",
  confirmed: "Confirmed",
  completed: "Completed",
  cancelled: "Cancelled",
  paid: "Paid",
  unpaid: "Unpaid",
  pay_at_desk: "Pay at desk",
  pending_payment: "Pending payment",
  refund_pending: "Refund pending",
  refunded: "Refunded",
  not_required: "No fee",
  created: "Initiated",
  failed: "Failed",
};

export default function StatusBadge({ value, testId }) {
  const key = (value || "pending").toLowerCase();
  return (
    <span
      data-testid={testId}
      className={`inline-block whitespace-nowrap rounded-full border px-2.5 py-0.5 font-mono text-[11px] font-medium ${
        STYLES[key] || STYLES.pending
      }`}
    >
      {LABELS[key] || value}
    </span>
  );
}
